export default __webpack_public_path__ + "static/header.voltadol-38c53e5e83521c3ab537b783c16d1c49.jpg";